import { useState } from "react";
import api from "@/lib/api";

export function AdminLogin({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("chartshub_token", data.access_token);
      onLogin(data.user);
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#050505] px-6">
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="w-full max-w-sm border border-white/10 bg-[#0A0A0A] p-10"
      >
        <p className="mb-2 font-heading text-2xl font-black uppercase tracking-tight">
          Rocky <span className="text-[#FFD700]">Agency</span>
        </p>
        <p className="mb-8 font-mono text-[10px] uppercase tracking-[0.25em] text-[#666666]">Admin access</p>
        <input
          data-testid="admin-email-input"
          type="email"
          required
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="mb-4 w-full border border-white/10 bg-black px-4 py-3 text-sm text-white outline-none transition-colors duration-300 focus:border-[#FFD700]/60"
        />
        <input
          data-testid="admin-password-input"
          type="password"
          required
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mb-6 w-full border border-white/10 bg-black px-4 py-3 text-sm text-white outline-none transition-colors duration-300 focus:border-[#FFD700]/60"
        />
        {error && (
          <p data-testid="admin-login-error" className="mb-4 text-xs text-[#E63946]">
            {error}
          </p>
        )}
        <button
          data-testid="admin-login-submit"
          type="submit"
          disabled={loading}
          className="w-full rounded-full bg-[#FFD700] py-3 text-xs font-bold uppercase tracking-[0.15em] text-black transition-transform duration-300 hover:scale-[1.02] disabled:opacity-50"
        >
          {loading ? "Signing in..." : "Sign in"}
        </button>
      </form>
    </div>
  );
}
